import { defineComponent } from "vue";

export default defineComponent({
  name: "JSXButton",
  setup() {
    return () => <button>JSX Button</button>;
  },
});
